import { tableSortLabelClasses } from '@mui/material/TableSortLabel';
export var createMuiTableSortLabelOverrides = function (_a) {
    var _b, _c;
    var tokens = _a.tokens;
    return {
        styleOverrides: {
            root: (_b = {},
                _b["&.".concat(tableSortLabelClasses.active)] = (_c = {
                        color: tokens.color_fg_bold
                    },
                    _c["& .".concat(tableSortLabelClasses.icon)] = {
                        color: tokens.color_fg_bold,
                    },
                    _c),
                _b),
            icon: {
                fontSize: 'inherit',
                height: '1em',
                width: '1em',
            },
        },
    };
};
